import { useEffect, useRef } from 'react';

function wait(delay: number): Promise<void> {
	// eslint-disable-next-line no-promise-executor-return
	return new Promise((resolve) => setTimeout(resolve, delay));
}

async function timeout(handler: () => void | Promise<void>, delay: number) {
	await wait(delay);
	handler();
}

export type Callback = (() => Promise<void>) | (() => void);

export function useInterval(callback: Callback, delay: number | null): void {
	const callbackRef = useRef(callback);
	const activeRef = useRef(true);

	callbackRef.current = callback;

	useEffect(() => {
		if (delay === null) {
			return;
		}

		const handle = async() => {
			if (!activeRef.current) {
				return;
			}

			const callbackResult = callbackRef.current();

			const resultAsPromise = callbackResult as Promise<void>;

			if (typeof resultAsPromise?.then === 'function') {
				await resultAsPromise;
			}

			timeout(handle, delay);
		};

		timeout(handle, delay);

		return () => {
			activeRef.current = false;
		};
	}, [ delay ]);
}
